type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
};

const PlayIcon = (props: Props) => {
  const { width = '24', height = '24', viewBox = '0 0 24 24' } = props;
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M12 0C18.6274 0 24 5.37257 24 12C24 18.6274 18.6274 24 12 24C5.37257 24 0 18.6274 0 12C0 5.37257 5.37257 0 12 0Z"
        fill="#F2D093"
      />
      <path
        d="M8.70607 16.2461C8.70562 16.4132 8.75023 16.5773 8.83521 16.7211C8.92019 16.8649 9.04239 16.9832 9.18893 17.0633C9.33009 17.1448 9.49022 17.1877 9.65321 17.1877C9.81622 17.1877 9.97634 17.1448 10.1175 17.0633L16.7939 12.699C16.9243 12.6149 17.0314 12.4994 17.1056 12.3631C17.1798 12.2269 17.2187 12.0742 17.2187 11.919C17.2187 11.7639 17.1798 11.6112 17.1056 11.475C17.0314 11.3387 16.9243 11.2232 16.7939 11.139L10.0989 6.8119C9.95777 6.7304 9.79764 6.6875 9.63464 6.6875C9.47165 6.6875 9.31152 6.7304 9.17036 6.8119C9.02382 6.89208 8.90162 7.01031 8.81664 7.15412C8.73166 7.29793 8.68705 7.462 8.6875 7.62904L8.70607 16.2461Z"
        fill="#1F1919"
      />
    </svg>
  );
};

export default PlayIcon;
